import React, { FunctionComponent } from 'react';

import valueIcon from '../../assets/value_icon.svg';
import { DatabaseEntryPickerOptionContainer } from '../entryPicker/databaseEntryPicker.styles';

export interface DatabaseEntryPickerOptionProps {
  label: string;
}

const DatabaseValuePickerOption: FunctionComponent<DatabaseEntryPickerOptionProps> = ({
  label,
}) => {
  return (
    <DatabaseEntryPickerOptionContainer>
      <img src={valueIcon} />
      {label}
    </DatabaseEntryPickerOptionContainer>
  );
};

export default DatabaseValuePickerOption;
